import API from "./api";
import { openAuthFile } from "./fileOpen";

/** PDF branding presets for H&S downloads — cached per session, invalidated when presets change. */
let cache = null;
let inflight = null;

export const loadPdfBrand = (force = false) => {
  if (cache && !force) return Promise.resolve(cache);
  if (inflight && !force) return inflight;
  inflight = API.get("/pdf-brand/presets").then((r) => { cache = r.data; return cache; }).catch(() => { cache = { presets: [], default_id: "", tenant: {} }; return cache; }).finally(() => { inflight = null; });
  return inflight;
};

export const invalidatePdfBrand = () => { cache = null; window.dispatchEvent(new CustomEvent("pdf-brand-changed")); };

/** Which preset a client's paperwork uses ({preset_id, inherited_from, effective_id, effective_name}); null when unknown. */
export const loadClientPdfBrand = (clientId) => (clientId ? API.get(`/pdf-brand/clients/${clientId}`).then((r) => r.data).catch(() => null) : Promise.resolve(null));

export const encodeOpts = (opts) => btoa(unescape(encodeURIComponent(JSON.stringify(opts)))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

const withParam = (url, key, value) => `${url}${url.includes("?") ? "&" : "?"}${key}=${encodeURIComponent(value)}`;

/** URL for an H&S PDF: explicit preset id, unsaved opts, "none" (company branding as-is) or the workspace default. */
export const hsePdfUrl = (url, { presetId, opts } = {}) => {
  if (opts) return withParam(url, "pdf_opts", encodeOpts(opts));
  if (presetId) return withParam(url, "pdf_preset", presetId);
  return withParam(url, "pdf_preset", "default");
};

export const openHsePdf = (url, sel) => openAuthFile(hsePdfUrl(url, sel));
